import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyCz5V4Wqg4LDe4SYSxGHsOXh69SdnNV1ek',
  authDomain: 'whitesides-family-blog.firebaseapp.com',
  projectId: 'whitesides-family-blog',
  storageBucket: 'whitesides-family-blog.firebasestorage.app',
  messagingSenderId: '921589260470',
  appId: '1:921589260470:web:865e2ea68c1f9fe0658617',
  measurementId: 'G-VEK84N9VCY',
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
